import { useRouter as useNextRouter } from "next/router";
import type React from "react";
import { useEffect } from "react";
import { FullscreenSpinner, GrantedTextLogo, useMedia, type ViewProps, validToken, XStack, YStack } from "@medbillai/ui";
import { useRouter } from "@medbillai/navigation/router";
import { homeUrl } from "@medbillai/utils";
import { useAuth } from "../../lib/auth";
import { rememberLandingEntry } from "../../lib/openedInApp";
import { CasesPanelProvider } from "../../provider/cases-panel/CasesPanelProvider";
import { CasesSlidePanel } from "./components/CasesSlidePanel.web";
import { MobileNavPopover } from "./components/MobileNavPopover.web";
import { isTabRoot, WebNavigation } from "./components/WebNavigation.web";
export type HomeLayoutProps = {
  children?: React.ReactNode;
  padded?: boolean;
  fullPage?: boolean;
  backgroundColor?: ViewProps["backgroundColor"];
  hideTabs?: boolean;
};
export const HomeLayout = ({
  children,
  fullPage = false,
  padded = false,
  backgroundColor = "$surface1",
  hideTabs = false
}: HomeLayoutProps) => {
  const {
    isReady
  } = useAuth();
  const {
    pathname
  } = useNextRouter();
  const media = useMedia();
  useEffect(rememberLandingEntry, []);
  if (!isReady) {
    return <FullscreenSpinner />;
  }
  return <CasesPanelProvider data-sentry-element="CasesPanelProvider" data-sentry-component="HomeLayout" data-sentry-source-file="layout.web.tsx">
      <XStack f={1} height={validToken("100dvh")} overflow="hidden" backgroundColor={backgroundColor} data-sentry-element="XStack" data-sentry-source-file="layout.web.tsx">
        {media.gtSm ? <WebNavigation /> : null}
        <YStack f={1} overflow="hidden" position="relative" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
          {media.gtSm || hideTabs || !isTabRoot(pathname) ? null : <RootBar />}
          <CasesSlidePanel data-sentry-element="CasesSlidePanel" data-sentry-source-file="layout.web.tsx" />
          <YStack {...fullPage && {
          flex: 1
        }} {...padded && {
          maxWidth: 800,
          mx: "auto",
          px: "$2",
          width: "100%"
        }} f={1} overflow="scroll" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
            {children}
          </YStack>
        </YStack>
      </XStack>
    </CasesPanelProvider>;
};
const RootBar = () => {
  const router = useRouter();
  return <XStack height="$4.5" jc="space-between" ai="center" paddingLeft="$4" paddingRight="$sp2" data-sentry-element="XStack" data-sentry-component="RootBar" data-sentry-source-file="layout.web.tsx">
      <YStack onPress={() => router.push(homeUrl())} cursor="pointer" justifyContent="center" height="100%" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
        <GrantedTextLogo width={80} height={16} data-sentry-element="GrantedTextLogo" data-sentry-source-file="layout.web.tsx" />
      </YStack>
      <MobileNavPopover data-sentry-element="MobileNavPopover" data-sentry-source-file="layout.web.tsx">
        <WebNavigation data-sentry-element="WebNavigation" data-sentry-source-file="layout.web.tsx" />
      </MobileNavPopover>
    </XStack>;
};